export const MAX_LENGTH_PRODUCTS = 0;
export const MAX_LENGTH_ARTICLES = 0;
